export const cartTemplate = () => {
  const cart = window.Carbon.Cart;

  const $cartTemplate = document.querySelector("section.cart-template");
  if ($cartTemplate) {
    cart.setUpCartTemplate($cartTemplate);
  }
};

export default cartTemplate;
